import {
  DeleteOutlined,
  DownOutlined,
  EditOutlined,
  ExclamationCircleOutlined,
  MailOutlined,
} from "@ant-design/icons";
import {
  Button,
  Checkbox,
  Col,
  Divider,
  Dropdown,
  MenuProps,
  Modal,
  Popover,
  Radio,
  RadioChangeEvent,
  Row,
  Select,
  Space,
  Tag,
} from "antd";
import { Option } from "antd/es/mentions";
import { useEffect, useState } from "react";
import { MdOutlineSubject } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";



import "./nonMembersList.scss";
import { fetchUsersList, multiFunctionDeleteUsers, resendEmail } from "../../../features/users/usersSlice";
import { handleApiResponse } from "../../../utils/helper";
import { appDispatch, RootState } from "../../../app/store";
import { fetchSitesList, resetFetchSitesList } from "../../../features/sites/sitesSlice";
import { fetchSpecialityList, resetFetchSpecialityList } from "../../../features/speciality/specialitySlice";
import { fetchRolesList, resetFetchRolesList } from "../../../features/userRoles/userRolesSlice";
import { fetchONSpecialities } from "../../../features/superAdmin/requestLIsts/requestListsSlice";
import { fetchDeletedMembersList, fetchLocations, fetchMembersList, fetchNonMembersList, fetchSites, filterMembers } from "../../../features/members/membersSlice";

interface UserTableActionProps {
  selectedRows: any;
  fetchUsersListData?: any[];
  activeTab: any;
  selectedAlphabet?: any;
  onSpecialityChange: any;
  selectedSpeciality: any;
  onActiveChange: any;
  onClearAll: any;
  onRoleChange: any;
  roleCheckedList: any;
  onSiteChange?: any;
  setUseSelectedRows?: any;
  resetTableSelection?: any;
  onFilterResults?: (results: any[]) => void; // <-- NEW
    setUpdatedData: React.Dispatch<React.SetStateAction<any[]>>;

}

const { confirm } = Modal;

const NonMemberListAction: React.FC<UserTableActionProps> = ({
  selectedRows,
  selectedAlphabet,
  activeTab,
  fetchUsersListData,
  onSpecialityChange,
  onSiteChange,
  onActiveChange,
  onClearAll,
  onRoleChange,
  setUseSelectedRows,
  resetTableSelection, onFilterResults, setUpdatedData
}) => {
  const [site, setSite] = useState("All");
  const [speciality, setSpeciality] = useState("All");
  const [active, setActive]: any = useState([]);
  const [roleCheckedList, setRoleCheckedList] = useState<string>("");
  const [isPopoverVisible, setPopoverVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [alphabet, setAlphabet] = useState("All");
  const [selectedRole, setSelectedRole] = useState<any[]>([]);
  const [selectedSpecialty, setSelectedSpecialty] = useState<any[]>([]);
  const [selectedCity, setSelectedCity] = useState<any[]>([]);
  const [selectedState, setSelectedState] = useState<any[]>([]);
  const [selectedZipCode, setSelectedZipCode] = useState<any[]>([]);
  const [selectedSite, setSelectedSite] = useState<any[]>([]);

  const [membershipPlans, setMembershipPlans] = useState<string[]>([]);

  const [pageNumber, setPageNumber] = useState(1);

  const {
    ONSpecialitiesListData,
    isLoading: isONSpecialitiesLoading
  } = useSelector((state: RootState) => state.requestLsts.fetchONSpecialities);

  const {
    ONRolesListData,
    isLoading: isONRolesLoading
  } = useSelector((state: RootState) => state.requestLsts.fetchONRoles);

  // const {
  //   ONStateListData,

  // } = useSelector((state: RootState) => state.members.fetchLocation.fetchLocationData);


  const { cities, states, zipcodes } = useSelector(
    (state: RootState) => state.members.fetchLocation.fetchLocationData || {}
  );
  const sites = useSelector(
    (state: RootState) => state.members.fetchSite.fetchSiteData || []
  );
  console.log(sites, "sitessss")

  const [deleteMethodState, setDeleteMethodState] = useState<{
    delete_ids: number[];
    deactivate_ids: number[];
    activate_ids: number[];
  }>({
    delete_ids: [],
    deactivate_ids: [],
    activate_ids: [],
  });
  const [searchquery, setSearchquery] = useState<string>("");
  const dispatch = useDispatch<appDispatch>();
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const thunkArgs = {};
    dispatch(fetchSitesList(arr));
    dispatch(fetchSpecialityList(params));
    dispatch(fetchRolesList());
    dispatch(fetchLocations(thunkArgs))
    dispatch(fetchSites(thunkArgs))

    return () => {
      dispatch(resetFetchSitesList());
      dispatch(resetFetchSpecialityList());
      dispatch(resetFetchRolesList());
    };
  }, []);

  const handleFilter = () => {
    // const payload = {
    //   subscription_plan_ids: membershipPlans,
    //   role_ids: selectedRole,
    //   specialty_ids: selectedSpecialty,
    //   member_type: activeTab === "nonMembers" ? "NON_MEMBER" : activeTab,
    //   isdeleted :true,
    // };

    let payload: any = {
      subscription_plan_ids: membershipPlans,
      role_ids: selectedRole,
      specialty_ids: selectedSpecialty,
      practice_site_ids: selectedSite,
      practice_city_id: selectedCity,
      practice_state_id: selectedState,
      practice_zipcode_id: selectedZipCode
    };

    // if activeTab === "deleted" → add isdeleted, else add member_type
    if (activeTab === "deleted") {
      payload.isdeleted = true;
    } else {
      payload.member_type = activeTab === "nonMembers" ? "NON_MEMBER" : activeTab;
    }

    dispatch(filterMembers(payload))
      .unwrap()
      .then((result) => {

        if (onFilterResults) {
          onFilterResults(result?.result?.data); // <-- send to parent
        }
      })
      .catch((error) => {
        console.error("Error fetching filtered results:", error);
      });
  };

  const handleSelectAll = (
    e: any,
    handleChange: any,
    options: any,
    name?: string
  ) => {
    if (e.target.checked) {
      handleChange(options.map((data: any) => data.id), "");
    } else {
      handleChange([], "");
    }
  };
  const handleSpecialtyChange = (value: any) => {
    setSelectedSpecialty(value);

  };


  const handleCityChange = (value: any) => {
    setSelectedCity(value);

  };


  const handleStateChange = (value: any) => {
    setSelectedState(value);

  };

  const handleSiteChange = (value: any) => {
    setSelectedSite(value)
  }

  const handleZipCodeChange = (value: any) => {
    setSelectedZipCode(value);

  };

  const handleMembershipPlansChange = (values: string[]) => {
    setMembershipPlans(values);

  };

  const handleActiveChange = (e: RadioChangeEvent) => {
    setActive(e.target.value);
    onActiveChange(e.target.value);
    setUseSelectedRows([]);
  };



  const TextWithCheckbox = (props: any) => {
    return (
      <div>
        <Checkbox
          checked={props.checked}
          style={{ margin: "0 .5rem 0 0rem" }}
        />
        {props.children}
      </div>
    );
  };


  //handle to resend email to selected users(row)
  const handleResendEmail = () => {
    const userIdsToResendEmail = selectedRows.map((item: any) => item.id);
    const selectedUsersName = selectedRows.map((item: any) => item.username).join(', ');

    const payload = {
      selected_ids: userIdsToResendEmail,
    };
    confirm({
      title: "Re-Send Email confirmation",
      icon: <ExclamationCircleOutlined />,
      centered: true,
      content: (<p>Are you sure you want to Re-send Email to the  <b>{selectedUsersName}</b> ?</p>),
      onOk() {
        dispatch(resendEmail(payload)).then(handleApiResponse);
        resetTableSelection()
      },
      onCancel() { },
    });

  };
  const items: MenuProps["items"] = [
    {
      label: "--- Select ---",
      key: 0,
    },
    {
      label:
        selectedRows && selectedRows[0]?.is_active
          ? "Deactivate Selected User"
          : "Activate Selected User",
      disabled:
        (selectedRows && selectedRows.length === 0) ||
        selectedRows === undefined,
      key: "2",
      icon: <DeleteOutlined />,
      onClick: () => {
        const isUserActive = selectedRows[0]?.is_active;
        confirm({
          title: isUserActive
            ? "Deactivate confirmation"
            : "Activate confirmation",
          icon: <ExclamationCircleOutlined />,
          centered: true,
          content: isUserActive
            ? "Are you sure you want to deactivate?"
            : "Are you sure you want to activate?",
          onOk() {
            const userIdsToChangeStatus = selectedRows.map(
              (item: any) => item.id
            );

            if (isUserActive) {
              // Deactivate the selected user
              const updatedDeleteMethod = {
                ...deleteMethodState,
                deactivate_ids: [
                  ...deleteMethodState.deactivate_ids,
                  ...userIdsToChangeStatus,
                ],
              };
              dispatch(multiFunctionDeleteUsers(updatedDeleteMethod))
                .then((data) => {
                  if (data.payload.isSuccess) {
                    resetTableSelection()
                    toast.success(data.payload.message);
                  } else {
                    toast.error(data.payload);
                  }
                })
                .then((data) => dispatch(fetchUsersList({ searchquery, pageNumber })));

            } else {
              // Activate the selected user
              const updatedActivateMethod = {
                ...deleteMethodState,
                activate_ids: [
                  ...deleteMethodState.activate_ids,
                  ...userIdsToChangeStatus,
                ],
              };
              dispatch(multiFunctionDeleteUsers(updatedActivateMethod))
                .then((data) => {
                  if (data.payload.isSuccess) {
                    resetTableSelection()
                    toast.success(data.payload.message);
                  } else {
                    toast.error(data.payload);
                  }
                })
                .then((data) =>
                  dispatch(fetchUsersList({ searchquery, pageNumber }))
                );
            }
          },
          onCancel() { },
        });
      },
    },

    {
      label: "Resend Email",
      disabled:
        (selectedRows && selectedRows.length === 0) ||
        selectedRows === undefined,
      key: "1",
      icon: <MailOutlined />,
      onClick: () => {
        handleResendEmail();
      },
    },
  ];

  const initiateClear = () =>{
    setSelectedSpecialty([]);
    setSelectedRole([]);
    setSelectedSite([]);
    setSelectedZipCode([]);
    setSelectedState([]);
    setSelectedCity([]);
  }

  const handleRoleChange = (value: any) => {
    setSelectedRole(value);
    dispatch(fetchONSpecialities({ roleIDs: value.join(",") }))

  };

  const tagRender = (props: any) => {
    const { label, value, closable, onClose } = props;
    const onPreventMouseDown = (event: React.MouseEvent<HTMLSpanElement>) => {
      event.preventDefault();
      event.stopPropagation();
    };

    return (
      <Tag
        onMouseDown={onPreventMouseDown}
        closable={closable}
        onClose={onClose}
        style={{
          marginRight: 3, padding: ".25rem",
        }}
      >
        {label?.props?.children ? label?.props?.children : null}
      </Tag>
    );
  };



  const clearFilters = () => {
    setSearchquery("")
initiateClear()
    onClearAll();
    setPopoverVisible(false);
  };

  const arr = {
    searchQuery: "",
    isSearchApi: false,
  };

  const params = {
    searchQuery: "",
    activeStatus: 'true',
    role: ""
  };

  return (
    <div className="user-table-container">
      <Row justify="end" style={{ marginBottom: "1rem" }}>
        <Col>
          <Button
            icon={<MdOutlineSubject />}
            className="filter-button"
            onClick={() => {
              setPopoverVisible(true);
              if (setUseSelectedRows) {
                setUseSelectedRows([]);
              }
            }}
          >
            {isMobile ? "" : "Filter"}
          </Button>
        </Col>
      </Row>
      <Modal
        width={600}
        centered={true}
        closeIcon={false}
        open={isPopoverVisible}
        footer={[
       <Button 
  key="cancel" 
  onClick={() => {
    setPopoverVisible(false);
    setSelectedSpecialty([]);
    setSelectedRole([]);
    setSelectedSite([]);
    setSelectedZipCode([]);
    setSelectedState([]);
    setSelectedCity([]);
  }}
>
  Cancel
</Button>,
          <Button
            key="apply"
            type="primary"
            style={{ margin: "0 0.5rem 1rem 1rem" }}
            onClick={() => {
              setPopoverVisible(false);
              handleFilter();
            }}
          >
            OK
          </Button>,
        ]}
      >
        <div
          className="popover-content"
          style={{
            padding: "10px",
            maxHeight: "400px",
            overflowY: "auto",
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))", // ✅ responsive columns
            gap: "1rem",
          }}
        >
          <div
            className="popover-header"
            style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "space-between" }}
          >
            <h4>Filter</h4>
            <Button onClick={clearFilters} className="clear-all-button">
              Clear All
            </Button>
          </div>


          {/* By Role */}
          <div className="popover-item">
            <label className="label-text">By Role</label>
            <Select
              mode="multiple"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children as any)?.props?.children
                  ?.toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              style={{ width: "100%" }}
              className="role-select"
              onChange={handleRoleChange}
              placeholder="Select Roles"
              maxTagCount="responsive"
              value={selectedRole}
              virtual={false}
              tagRender={tagRender}
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "5px 12px 4px" }}>
                    <Checkbox
                      checked={
                        selectedRole.length > 0 &&
                        selectedRole.length === ONRolesListData?.length
                      }
                      onChange={(e) =>
                        handleSelectAll(e, handleRoleChange, ONRolesListData, "role")
                      }
                    >
                      Select All
                    </Checkbox>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
            >
              {ONRolesListData?.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  <TextWithCheckbox checked={selectedRole?.includes(item?.id)}>
                    {item?.name}
                  </TextWithCheckbox>
                </Option>
              ))}
            </Select>
          </div>

          {/* By Specialty */}
          <div className="popover-item">
            <label className="label-text">By Speciality</label>
            <Select
              mode="multiple"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children as any)?.props?.children
                  ?.toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              disabled={ONSpecialitiesListData?.length === 0}
              style={{ width: "100%" }}
              className="specialty-select"
              onChange={handleSpecialtyChange}
              placeholder="Select Specialty"
              maxTagCount="responsive"
              value={selectedSpecialty}
              virtual={false}
              tagRender={tagRender}
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "5px 12px 4px" }}>
                    <Checkbox
                      checked={
                        selectedSpecialty.length > 0 &&
                        selectedSpecialty.length === ONSpecialitiesListData?.length
                      }
                      onChange={(e) =>
                        handleSelectAll(
                          e,
                          handleSpecialtyChange,
                          ONSpecialitiesListData,
                          "specialty"
                        )
                      }
                    >
                      Select All
                    </Checkbox>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
            >
              {ONSpecialitiesListData?.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  <TextWithCheckbox checked={selectedSpecialty?.includes(item?.id)}>
                    {item?.name}
                  </TextWithCheckbox>
                </Option>
              ))}
            </Select>
          </div>


          {/* By Site */}
          <div className="popover-item">
            <label className="label-text">By Site</label>
            <Select
              mode="multiple"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children as any)?.props?.children
                  ?.toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              style={{ width: "100%" }}
              className="role-select"
              onChange={handleSiteChange}
              placeholder="Select Site"
              maxTagCount="responsive"
              value={selectedSite}
              virtual={false}
              tagRender={tagRender}
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "5px 12px 4px" }}>
                    <Checkbox
                      checked={
                        selectedSite.length > 0 && selectedSite.length === sites?.length
                      }
                      onChange={(e) =>
                        handleSelectAll(e, handleSiteChange, sites, "sites")
                      }
                    >
                      Select All
                    </Checkbox>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
            >
              {sites?.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  <TextWithCheckbox checked={selectedSite?.includes(item?.id)}>
                    {item?.name}
                  </TextWithCheckbox>
                </Option>
              ))}
            </Select>
          </div>

          {/* By Zip Code */}
          <div className="popover-item">
            <label className="label-text">By Zip Code</label>
            <Select
              mode="multiple"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children as any)?.props?.children
                  ?.toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              style={{ width: "100%" }}
              className="role-select"
              onChange={handleZipCodeChange}
              placeholder="Select Zip Code"
              maxTagCount="responsive"
              value={selectedZipCode}
              virtual={false}
              tagRender={tagRender}
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "5px 12px 4px" }}>
                    <Checkbox
                      checked={
                        selectedZipCode.length > 0 &&
                        selectedZipCode.length === zipcodes?.length
                      }
                      onChange={(e) =>
                        handleSelectAll(e, handleZipCodeChange, zipcodes, "zipcodes")
                      }
                    >
                      Select All
                    </Checkbox>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
            >
             {zipcodes?.map((item: any) => (
  <Option key={item.id} value={item.id}>
    <TextWithCheckbox checked={selectedZipCode?.includes(item?.id)}>
      {item?.zipcode}
    </TextWithCheckbox>
  </Option>
))}
            </Select>

          </div>


          {/* By State */}
          <div className="popover-item">
            <label className="label-text">By State</label>
            <Select
              mode="multiple"
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children as any)?.props?.children
                  ?.toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              disabled={states?.length === 0}
              style={{ width: "100%" }}
              className="specialty-select"
              onChange={handleStateChange}
              placeholder="Select State"
              maxTagCount="responsive"
              value={selectedState}
              virtual={false}
              tagRender={tagRender}
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "5px 12px 4px" }}>
                    <Checkbox
                      checked={
                        selectedState.length > 0 &&
                        selectedState.length === states?.length
                      }
                      onChange={(e) =>
                        handleSelectAll(e, handleStateChange, states, "state")
                      }
                    >
                      Select All
                    </Checkbox>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
            >
              {states?.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  <TextWithCheckbox checked={selectedState?.includes(item?.id)}>
                    {item?.name}
                  </TextWithCheckbox>
                </Option>
              ))}
            </Select>

          </div>

          {/* By City */}
          <div className="popover-item">
            <label className="label-text">By City</label>
            <Select
              mode="multiple"
              disabled={cities?.length === 0}
              style={{ width: "100%" }}
              className="specialty-select"
              onChange={handleCityChange}
              placeholder="Select City"
              maxTagCount="responsive"
              value={selectedCity}
              virtual={false}
              tagRender={tagRender}
              showSearch
              optionFilterProp="children"
              filterOption={(input, option) =>
                (option?.children as any)?.props?.children
                  ?.toString()
                  .toLowerCase()
                  .includes(input.toLowerCase())
              }
              dropdownRender={(menu) => (
                <>
                  <Space style={{ padding: "5px 12px 4px" }}>
                    <Checkbox
                      checked={
                        selectedCity.length > 0 &&
                        selectedCity.length === cities?.length
                      }
                      onChange={(e) =>
                        handleSelectAll(e, handleCityChange, cities, "city")
                      }
                    >
                      Select All
                    </Checkbox>
                  </Space>
                  <Divider style={{ margin: "8px 0" }} />
                  {menu}
                </>
              )}
            >
              {cities?.map((item: any) => (
                <Option key={item.id} value={item.id}>
                  <TextWithCheckbox checked={selectedCity?.includes(item?.id)}>
                    {item?.name}
                  </TextWithCheckbox>
                </Option>
              ))}
            </Select>
          </div>

          {/* Membership Plan (full row) */}
          {activeTab === "members" && (
            <div className="popover-item" style={{ gridColumn: "1 / -1" }}>
              <label className="label-text"> By Membership Plan</label>
              <Select
                placeholder={"Select Plan"}
                mode="multiple"
                value={membershipPlans}
                onChange={handleMembershipPlansChange}
                style={{ width: "100%", marginTop: ".5rem" }}
                virtual={false}
                showSearch
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option?.children?.toLowerCase().includes(input.toLowerCase())
                }
              >
                <Select.Option value="2">Basic</Select.Option>
                <Select.Option value="3">Plus</Select.Option>
                <Select.Option value="1">Free</Select.Option>
              </Select>
            </div>
          )}
        </div>
      </Modal>
    </div>
  );
};

export default NonMemberListAction;
